import { Injectable } from '@angular/core';
import { ConfigService } from '../shared/ngx-config/core';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private settings: any;

  constructor(config: ConfigService) {
    this.settings = config.getSettings();
  }

  public get baseUrl() {
    return this.settings.baseUrl;
  }

  public get authKey() {
    return this.settings.authKey;
  }

  public get rowsCount() {
    return this.settings.rowsCount;
  }

  public get pageLinksCount() {
    return this.settings.pageLinksCount;
  }

  public get alternateEmailDomain() {
    return this.settings.alternateEmailDomain;
  }

  public get minPasswordLength() {
    return this.settings.minPasswordLength;
  }
}
